module.exports = __webpack_public_path__ + "img/1 1.4c6c4a42.png";